var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod-demo-echarts"},[(_vm.orgFlag && _vm.isAdmin == false)?_c('mainOrgHome'):_vm._e(),(_vm.natFlag && _vm.isAdmin == false)?_c('mainNaturalHome'):_vm._e(),(_vm.isAdmin == true)?_c('mainSuperHome'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }